// i18n area 'networks' — locale lv-LV (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.lv-LV.meta.json.
import type { enUS } from './networks'

export const lvLV: typeof enUS = {
  networks: {
    common: {
      name: 'Nosaukums',
      scope: 'Scope',
      operState: 'Stāvoklis',
      actions: 'Darbības',
      create: 'Izveidot',
      close: 'Aizvērt',
      cancel: 'Atcelt',
      delete: 'Dzēst',
      edit: 'Rediģēt',
      save: 'Saglabāt',
      editError: 'Rediģēšana neizdevās',
      search: 'Meklēt pēc nosaukuma',
      empty: 'Šeit vēl nekā nav',
      saveError: 'Neizdevās saglabāt',
      loadError: 'Neizdevās ielādēt — vai TVirt backend ir sasniedzams?',
      createError: 'Izveide neizdevās',
      deleteError: 'Dzēšana neizdevās',
      deleteConfirmTitle: 'Vai dzēst {name}?',
      deleteConfirmBody: 'Darbība nav atgriezeniska.',
      nameHint: 'Mazie burti, cipari un defises (DNS-1123)',
      up: 'Aktīva',
      down: 'Nav aktīva',
      unknown: 'Nezināms',
      usedByVMs: 'VM',
      emptyTable: 'Nav neviena ieraksta — pievienojiet to ar pogu +'
    },
    dialogTabs: {
      general: 'Vispārīgi',
      base: 'Pamatdefinīcija',
      advanced: 'Papildu konfigurācija',
      reserved: 'TVirt rezervētie diapazoni',
      position: 'Novietojums',
      network: 'Tīkla konfigurācija',
      hosts: 'Iesaistītie mezgli'
    },
    reservedRanges: {
      note: 'Šie ir TVirt rezervētie IP diapazoni, ko tas var izmantot, lai automātiski piešķirtu adresi VM, konteineriem u. c. PIEZĪME: šo diapazonu IP adreses ārpus TVirt nedrīkst izmantot ārēji pakalpojumi vai iekārtas.',
      from: 'No',
      to: 'Līdz'
    },
    overlay: {
      title: 'Overlay tīkli',
      createTitle: 'Izveidot overlay tīklu',
      editTitle: 'Rediģēt overlay tīklu',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — piešķirts automātiski, ja atstāts tukšs',
      subnet: 'Apakštīkls',
      subnetHint: 'Overlay CIDR — IPAM no tā automātiski atvasina reģistra ierakstu',
      mtu: 'MTU',
      weight: 'Svars',
      ceilMbps: 'Griesti (Mbps)',
      fairnessHint: 'Svars darbojas tikai sadursmes gadījumā: brīvā saitē katrs tīkls var izmantot visu joslas platumu. Griesti tomēr darbojas vienmēr.',
      contention: 'Sacensība',
      contentionTip: 'Vismaz viens mezgls šī tīkla klasē novēro atmešanu vai overlimit KOPĀ ar rindu: uplink joslas platums tiek apstrīdēts un svari darbojas. Cik un kopš kura brīža — mezgla net.shaping.* sērijās.',
      firewallPolicy: 'Firewall politika',
      hosts: 'Hosti',
      hostsTitle: 'Iesaistītie mezgli',
      hostsHint: 'Katrs mezgls deklarē savu underlay endpoint — izvēle no mezgla ĪSTAJĀM adresēm, kas nolasītas no tā tīkla konfigurācijas; neobligātajai overlay adresei jābūt apakštīkla robežās. Dalība ir placement ierobežojums.',
      hostNode: 'Mezgls',
      hostUnderlay: 'Underlay IP',
      hostUnderlayPickNode: 'Vispirms izvēlieties mezglu',
      hostAddress: 'Adrese overlay tīklā (neobligāta)',
      hostAddressOutside: 'Ārpus overlay apakštīkla ({cidr})',
      addHost: 'Pievienot mezglu',

      // Round #156 (standarta dialogs): detaļu dialoga novērotās rindas.
      observedAt: 'Novērots',
      attachedNics: 'Pievienotās NIC'
    },
    services: {
      title: 'Tīkla pakalpojumi',
      createTitle: 'Izveidot tīkla pakalpojumu',
      editTitle: 'Rediģēt tīkla pakalpojumu',
      kind: 'Tips',
      kindCategory: 'Pakalpojumi',
      selectKindHint: 'Izvēlieties pakalpojuma tipu — pamatā esošais dēmons ir implementācijas detaļa, ko TVirt pārvalda jūsu vietā.',
      kindLabel: {
        dhcp: 'DHCP serveris',
        ntp: 'NTP serveris',
        vpn: 'VPN serveris',
        dns: 'DNS serveris',
        gateway: 'Gateway',
        'lb-rp': 'Slodzes balansētājs un reversais proxy',
        floatip: 'Peldošā IP'
      },
      kindDesc: {
        dhcp: 'Piešķir adreses apkalpotajos apakštīklos — pūli tiek atvasināti no tīkla apakštīkla, vārtejas un TVirt rezervētajiem diapazoniem.',
        dns: 'Autoritatīvs DNS deklarētajās zonās — ieraksti tiek atvasināti no IPAM, kam pievienojas jūsu manuālie.',
        gateway: 'Mezgls darbojas kā tīkla vārteja — NAT (DNAT, 1:1, SNAT/masquerade) plus statiskā maršrutēšana starp pievienotajiem tīkliem, pēc uzbūves pašatjaunojoša.',
        'lb-rp': 'Slodzes balansētājs / reversais starpniekserveris jūsu pakalpojumu priekšā — L4 vai L7 klausītāji pār dalībnieku pūliem vai pār Pod gatavajām instancēm, pārkonfigurēti darbības laikā.',
        ntp: 'Tīklu laika pakalpojums — ārēju upstream serveru relejs vai apkalpojošā mezgla pulkstenis, kas tiek pasniegts klientiem.',
        vpn: 'VPN koncentrators uz mezgla — WireGuard vai OpenVPN pēc jūsu izvēles: attālināta piekļuve ceļojošiem klientiem vai site to site tunelis starp diviem tīkliem.',
        floatip: 'Viena adrese, kas vienlaikus atrodas tikai uz vienas veselas App instances vai Pod un tās krišanas gadījumā pāriet uz nākamo veselo mērķi — failover bez dēmoniem; balansēšana paliek balansētājam.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Peldošā IP dzīvo izvēlētajā tīklā kā PAPILDU adrese turētājas instances vārdtelpā: bez portiem, bez balansēšanas, bez NAT — klienta IP paliek īsta.',
        address: 'Peldošā IP',
        targets: 'Mērķi',
        targetsHint: 'PRIORITĀTES secībā: pirmais veselais mērķis tur adresi. Pod nozīmē visas tā instances pēc replikas; katram mērķim ir savs veselības kritērijs. Katram mērķim jābūt pievienotam tam pašam tīklam.',
        targetKind: 'Mērķis',
        targetApp: 'App instance',
        targetPod: 'Pod (visas instances)',
        targetRef: 'Kurš',
        health: 'Veselība',
        healthRunning: 'Darbojas (katrs konteiners gatavs)',
        healthTcp: 'TCP savienojums',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Ports',
        path: 'Ceļš',
        addTarget: 'Pievienot mērķi',
        moveUp: 'Pārvietot augšup',
        moveDown: 'Pārvietot lejup',
        preempt: 'Preempt',
        preemptHint: 'Izslēgts (noklusējums): vesels turētājs patur adresi pat tad, ja atgriežas augstāks mērķis — bez svārstībām. Ieslēgts: pirmais veselais mērķis to tur vienmēr.',
        holder: 'Turētājs',
        noHolder: 'nav vesela mērķa',
        since: 'kopš',
        verdicts: 'Novērotie mērķi',
        healthy: 'vesels',
        unhealthy: 'nevesels',
        noVerdict: 'Vēl nav izlemts — autoritātes mezgls ieraksta pirmo spriedumu nākamajā gājienā.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Šī instance tur pakalpojuma {service} peldošo IP {address}'
      },
      poolSource: 'Galapunkti',
      poolSourceMembers: 'Statiskie dalībnieki',
      poolSourcePod: 'Pod gatavās instances',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Ports',
      poolBackendHint: 'Galapunkti seko Pod: instance pievienojas, kad darbojas ar katru konteineru gatavu, un uzreiz aiziet, kad tiek samazināta vai mirst. Aktīvā pārbaude pēc noklusējuma ir ieslēgta.',
      poolBackendCount: 'Pod {pod} gatavās instances portā {port}',
      node: 'Mezgls',
      enabled: 'Iespējots',
      parked: 'Nolikts malā',
      subnets: 'Apakštīkli',
      subnetsHint: 'Šīs instances apkalpotie IPAM apakštīkli — pūli tiek atvasināti no CIDR, vārtejas un TVirt rezervētajiem diapazoniem',
      noSubnets: 'Nav neviena IPAM apakštīkla — vispirms deklarējiet fabric loģisko tīklu (vai overlay apakštīklu): IPAM atvasinās no tiem',
      iface: 'Klausīšanās saskarne',
      ifaceHint: 'Resursdatora saskarne, uz kuras pakalpojums atver savu ligzdu (piem., tilts) — obligāta: tīkla pakalpojums ir pašpietiekams, "visas saskarnes" vairs nepastāv',
      dns: 'DNS serveri',
      domain: 'Domēns',
      detail: 'Apkalpo',
      subnetCount: '{n} apakštīkli',
      zones: 'Zonas',
      zonesHint: 'Tikai autoritatīvs — dēmons nekad neveic rekursiju. A ieraksti tiek atvasināti no mezglu deklarētajām adresēm norādītajos IPAM apakštīklos; reverse slēdzis apkalpo arī atbilstošās in-addr.arpa zonas (PTR). Vienu zonu flotē apkalpo ne vairāk kā viena DNS instance. Neobligātais nameserver ir FQDN, ko ieraksta NS/SOA ierakstos noklusējuma ns.<zona> vietā; ja tas ietilpst zonā, tā A ieraksts joprojām tiek atvasināts no apkalpojošā mezgla.',
      zoneName: 'Zonas nosaukums',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM apakštīkli',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Manuālie ieraksti',
      zoneRecordsHint: 'Viens rindā: nosaukums TIPS vērtība — tipi A, CNAME, MX, TXT. Nosaukuma sadursmes gadījumā manuālais ieraksts uzvar pār atvasināto.',
      addZone: 'Pievienot zonu',

      // lb-rp (3. viļņa pamati): listener uz iekļautajiem pūliem — bez engine,
      // pārkonfigurējams darbības laikā.
      lbListeningHint: 'Instance deklarē VIENU klausīšanās tīklu un VIENU adresi — katrs klausītājs to saista savā portā; otra adrese ir otrs pakalpojums.',
      listeners: 'Listener',
      listenersHint: 'Katrs klausītājs saista instances adresi savā portā L4 režīmā (TCP passthrough — baiti nekad netiek atvērti) vai L7 (HTTP) un pārsūta uz vienu no zemāk esošajiem pūliem. Adreses/porta pāri apkalpo ne vairāk kā viena instance mezglā. Izmaiņas stājas spēkā lidojumā — bez restarta, bez zaudētiem savienojumiem.',
      listenerName: 'Nosaukums',
      listenerMode: 'Režīms',
      modeL7: 'L7 — HTTP reversais proxy',
      modeL4: 'L4 — TCP passthrough',
      listenerPort: 'Ports',
      listenerPool: 'Pūls',
      addListener: 'Pievienot listener',
      pools: 'Pūli',
      poolsHint: 'Backend, uz kuriem nonāk datplūsma: statiski dalībnieki, balansēti pēc round-robin vai mazāk noslogotā principa, ar neobligātu aktīvu health check, kas izņem no rotācijas slimos dalībniekus.',
      poolName: 'Nosaukums',
      poolAlgorithm: 'Algoritms',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Mazāk noslogotais',
      poolCheck: 'Health check',
      checkNone: 'Nav',
      checkTcp: 'TCP savienojums',
      checkHttp: 'HTTP',
      poolCheckPath: 'Zondes ceļš',
      poolInterval: 'Intervāls (s)',
      poolMembers: 'Dalībnieki',
      poolMembersHint: 'Viens rindā: adrese:ports, neobligāti ar svaru (1-128) — piem. 10.0.0.21:8080 2',
      addPool: 'Pievienot pūlu',
      memberCount: '{n} dalībnieki',

      // ntp (ntp raunds — ratificēts 2026-08-03, saimes pēdējais kind):
      // režīms sarunvalodā, upstream saraksts tikai tur, kur tas kaut ko
      // nozīmē, tīkla pieslēgums pārmanto gateway etiķetes.
      listen: {
        assignment: 'Piešķiršana',
        assignmentStatic: 'Statiska adrese',
        assignmentAuto: 'Automātiska (TVirt rezervētie diapazoni)',
        autoHint: 'TVirt izvelk adresi no loģiskā tīkla rezervētajiem diapazoniem un tur to sticky — nekad netiek vilkta no jauna pie labojuma vai failover.',
        title: 'Klausītāji',
        hint: 'Tīkla pakalpojums ir pašpietiekams: katrs klausītājs deklarē savu tīklu (overlay, fabric loģisko tīklu vai neapstrādātu saskarni) un adresi tā apakštīklā — viens klausītājs uz adresi, aizstājējzīmes vairs nav. DNS un NTP drīkst klausīties vairākos tīklos un vairākās šo tīklu adresēs.',
        address: 'Klausīšanās adrese',
        add: 'Pievienot klausītāju'
      },
      ntp: {
        mode: 'Sinhronizācijas režīms',
        modeRelay: 'Ārējo serveru relejs',
        modeNodeClock: 'Mezgla pulkstenis',
        modeHint: 'Relejs pasniedz laiku, kas ņemts no deklarētajiem upstream serveriem; mezgla pulkstenis pasniedz apkalpojošā mezgla laiku — ko klasteris tik un tā tur sinhronizētu',
        servers: 'Upstream serveri',
        serversHint: 'Atdalīti ar komatu — hostnosaukums vai IP adrese; pakalpojums ņem laiku no šejienes un pasniedz to tīklam',
        port: 'Klausīšanās ports',
        listening: 'Klausās uz'
      },

      vpn: {
        engine: 'Dzinējs',
        engineHint: 'Izvēle ir jūsu, un tā vairs nemainās: WireGuard ir moderns, ātrs un kodolā; OpenVPN ir saderības veterāns (TCP, naidīgi tīkli)',
        engineLocked: 'Dzinējs ir nemaināms — cits dzinējs nozīmē jaunu pakalpojumu, atslēgas un sertifikāti nav pārnesami',
        mode: 'Režīms',
        modeRemote: 'Attālināta piekļuve',
        modeSite: 'Site to site',
        modeHint: 'Attālinātā piekļuve dod ceļojošiem klientiem adresi tunelī; site to site savieno divus tīklus',
        port: 'Klausīšanās ports',
        protocol: 'Transports',
        protocolWireguardHint: 'WireGuard runā tikai UDP',
        tunnelSubnet: 'Tuneļa apakštīkls',
        tunnelSubnetHint: 'Tīkls, kurā dzīvo klienti — reģistrēts IPAM reģistrā, rodas un mirst kopā ar šo pakalpojumu',
        dnsServers: 'Klientiem nosūtītie DNS',
        routes: 'Klientiem nosūtītie maršruti',
        routesHint: 'Ar komatu atdalīti tīkli, kas sasniedzami tunelī; tuneļa apakštīkls vienmēr ir iekļauts',
        peers: 'Peer',
        peersHint: 'Atstājiet publisko atslēgu tukšu, un TVirt ģenerēs atslēgu pāri — pēc tam piegādās to kopā ar profilu. Ielīmējiet atslēgu, un peer paturēs savu.',
        clients: 'Klienti',
        clientsHint: 'Katrs klients saņem sertifikātu, ko izdod šī pakalpojuma CA. Klienta noņemšana to ATSAUC: CRL tiek pārģenerēta uzreiz.',
        peerName: 'Nosaukums',
        publicKey: 'Publiskā atslēga',
        publicKeyMinted: 'To ģenerē TVirt',
        peerAddress: 'Adrese tunelī',
        peerAddressHint: 'Tukšs = piešķirta',
        allowedIps: 'Attālinātie apakštīkli',
        allowedIpsHint: 'Atdalīti ar komatu, maršrutēti caur šo peer',
        endpoint: 'Endpoint',
        presharedKey: 'Iepriekš koplietotā atslēga',
        keepalive: 'Keepalive (s)',
        addPeer: 'Pievienot peer',
        addClient: 'Pievienot klientu',
        auth: 'Autentifikācija',
        authTls: 'Sertifikāti (TLS)',
        remote: 'Attālinātais endpoint',
        remoteHint: 'attālinātā gala hosts:ports — tukšs nozīmē, ka šī puse gaida',
        peerRoutes: 'Attālinātie apakštīkli',
        serverPublicKey: 'Šī servera publiskā atslēga',
        ca: 'Sertifikācijas iestāde',
        listening: 'Klausās uz',
        tunnel: 'Tunelis',
        peerCount: '{n} peer',
        download: 'Lejupielādēt profilu',
        downloadError: 'Neizdevās eksportēt profilu',
        lastHandshake: 'Pēdējais handshake',
        never: 'nekad',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Savienots',
        idle: 'Dīkstāvē'
      },

      // Gateway (3. vilnis — dzimis kā nat, ratificēts 2026-08-01/02;
      // pārdēvēts un paplašināts 2026-08-03): trīs NAT noteikumu saimes plus
      // statiskie maršruti uz klausīšanās tīkla. Atbalstīta katra ratificētā forma.
      gateway: {
        attach: 'Klausīšanās tīkla tips',
        attachOverlay: 'Overlay tīkls',
        attachNetwork: 'Fabric loģiskais tīkls',
        attachInterface: 'Neapstrādāta saskarne',
        overlay: 'Overlay tīkls',
        network: 'Loģiskais tīkls',
        interface: 'Saskarnes nosaukums',
        interfaceHint: 'Hosta saskarne, ko TVirt nepārvalda — adrese tiek pieņemta kā dota',
        address: 'Klausīšanās adrese (vārteja)',
        addressHint: 'Vārtejas adrese, uz kuru norāda klienti — klausīšanās tīkla apakštīkla robežās',
        dnatTitle: 'DNAT noteikumi',
        dnatHint: 'Galamērķa NAT: sakritībai atbilstošā datplūsma tiek novirzīta uz jaunu adresi (un pēc izvēles jaunu portu). Jebkurš protokols no saraksta — porti tur, kur protokols tos nes.',
        snatTitle: 'SNAT noteikumi',
        snatHint: 'Avota NAT: sakritībai atbilstošā datplūsma iziet ar pārrakstītu avotu — jauna skaidra adrese (un pēc izvēles jauns ports) vai masquerade uz izejas adreses, ja atstāts tukšs.',
        oneToOneTitle: '1:1 NAT noteikumi',
        oneToOneHint: 'Katra pakete, kas adresēta ārējai adresei, tiek kartēta uz iekšējo, un iekšējais hosts iziet kā ārējais — visi protokoli, abos virzienos.',
        external: 'Ārējā adrese',
        internal: 'Iekšējā adrese',
        addOneToOne: 'Pievienot 1:1 noteikumu',
        family: 'Saime',
        protocol: 'Protokols',
        source: 'Avots (adrese/apakštīkls)',
        destination: 'Galamērķis (adrese/apakštīkls)',
        invert: 'NOT',
        srcPorts: 'Avota porti',
        dstPorts: 'Galamērķa porti',
        dstPortsHint: 'Ports vai diapazons (80, 8000-8099)',
        toAddress: 'Jaunā adrese',
        toPort: 'Jaunais ports',
        snatTo: 'Jaunais avots (tukšs = masquerade)',
        snatToHint: 'Skaidra avota adrese; tukšs = masquerade uz izejas adreses',
        addDnat: 'Pievienot DNAT noteikumu',
        addSnat: 'Pievienot SNAT noteikumu',
        routesTitle: 'Statiskie maršruti',
        routesHint: 'Mezgls maršrutē starp tīkliem, kuriem tas ir pievienots (IP forwarding ir ieslēgts); šie maršruti pievieno sasniedzamību ārpus tiem — tīrs kodols, dinamiskā maršrutēšana nāks nākamajā raundā.',
        routeDestination: 'Galamērķa apakštīkls',
        routeGateway: 'Next hop',
        routeMetric: 'Metrika',
        addRoute: 'Pievienot maršrutu',
        listening: 'Klausās uz',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} maršruti'
      },
      unknownSince: 'Nezināms — pēdējais ziņojums pirms {m} min',
      lastWord: 'Pēdējais vārds',

      // Round #156 (standarta dialogs): novērotās rindas un kind bloka
      // kopsavilkums tikai lasīšanai detaļu dialogā.
      reportObservedAt: 'Pēdējais ziņojums',
      lastErrorRow: 'Pēdējā kļūda',
      recordsCount: '{n} manuālie ieraksti',
      phase: {
        configured: 'Konfigurēts',
        running: 'Darbojas',
        error: 'Kļūda'
      },
      authorityNode: 'Authority (piešķiršana)',
      preferredNode: 'Vēlamais mezgls',
      preferredNodeHint: 'Maiga priekšroka, nekad ne ierobežojums: nākamajā izvietojuma lēmumā instance nolaižas šeit, ja dalībnieks ir piemērots — pati par sevi tā neko nepārvieto; gājiens ir "Nodot authority".',
      noPreference: 'Bez priekšrokas (automātisks izvietojums)',
      moving: 'Kustībā',
      movingTooltip: 'Novērots šeit, kamēr authority piešķir {node}: gājiens konverģē.',
      placement: {
        title: 'Izvietojums',
        loading: 'Notiek uzskaite…',
        loadError: 'Izvietojuma uzskaite neatbildēja — vēlāk jāmēģina vēlreiz.',
        draftHint: 'Uzskaite tiek aprēķināta no deklarētā tīkla pievienojuma: tā parādīsies, kad pakalpojums būs izveidots. Izveide tiek noraidīta, ja neviens dalībnieks to nevar apkalpot, un noraidījums nosauc mehānismu, kas iztukšoja kopu.',
        eligibleCount: '{n} no {m} dalībniekiem var apkalpot šo instanci',
        recommended: 'Ieteicams',
        eligible: 'Piemērots',
        notEligible: 'Nav piemērots',
        blockedReachability: 'tīkls nesasniedz šo dalībnieku',
        blockedRequireTag: 'bloķē pieprasīts tags (requireNodes)',
        blockedExcluded: 'izslēgts no simulācijas',
        preferenceUnknown: 'tas (vairs) nav klastera dalībnieks',
        preferenceIgnored: 'Priekšroka "{node}" šodien nav piemērota: {reason}. Noteicošais ir uzskaites ieteikums — nekad ne kļūda, pakalpojums dzīvo citur.',
        emptyReachability: 'Neviens dalībnieks nevar apkalpot šo instanci: tīkls nesniedzas nekur — neviena tagu korekcija nepalīdzēs. Jāsavieno mezgls ar kabeli, vai pakalpojums jāpārvieto turp, kur tīkls ir.',
        emptyRequireTag: 'Neviens dalībnieks nevar apkalpot šo instanci: kopu iztukšoja tieši pieprasītie tagi — jāizņem ieraksts no requireNodes, vai jāpiešķir tags kādam dalībniekam.',
        spof: 'Vienots atteices punkts',
        spofDetail: 'Instanci var uzņemt tikai viens dalībnieks: atteices brīdī failover nav, kur iet. Multi-listener pakalpojums pārvietojas kā VESELUMS — kandidātam jāredz VISI tā tīkli: tāda ir cena.',
        whatIf: 'Simulēt dalībnieku prombūtni',
        whatIfHint: 'Iztukšošanas what-if: jājautā PIRMS evakuācijas, nevis tas jāatklāj failover brīdī.',
        survives: 'Kad {nodes} nav, pakalpojumam joprojām ir mājas.',
        notSurvives: '{nodes} evakuācija atstāj šo pakalpojumu KRITUŠU: atvasinātais ierobežojums uzvar pār pieejamību (R30) — dzīvs dēmons tur, kur tīkls nesniedzas, nevienam nekalpo un neceļ nekādu trauksmi.',
        transfer: 'Nodot authority',
        transferError: 'Nodošana neizdevās',
        transferTarget: 'Mērķa dalībnieks',
        transferHint: 'Tiek piedāvāti tikai piemērotie dalībnieki — priekšroka derīgās kopas ietvaros, nekad ne override. Nekāda task: nākamais worker cikls IR gājiens (vecais mezgls nopļauj, jaunais atveido).'
      }
    },
    fabric: {
      tabDerivation: 'Derivācija',
      importNetwork: 'Importēt no cita fabric',
      importTitle: 'Importēt loģisko tīklu',
      importHint: 'Imports ir skaidra pievienošanās: tīkls paliek īpašniekam (tā pati identitāte, tas pats stem, tas pats bridge tvf-<stem>) un no šejienes tas tiek kartēts uz šī fabric portiem/LAGG — kartēt NOZĪMĒ apgalvot, ka piegāde nonāk tajā pašā L2 domēnā kā īpašniekam.',
      importPick: 'Īpašnieka tīkls',
      importNone: 'Nav ko importēt: citiem fabric nav sava tīkla, ko šis fabric jau nezinātu',
      importedNetworksTitle: 'Importētie tīkli',
      noImported: 'Nav importēta tīkla',
      importedFrom: 'importēts no {fabric}',
      importedBy: 'Importējuši: {list}',
      importedCount: '+{n} importēti',
      owner: 'Īpašnieks',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Noņemt importu',
      unimportConfirm: 'Noņemt tīkla {name} (īpašnieks {fabric}) importu no šī fabric? Tiek noraidīts, kamēr to kartē šī fabric ports vai LAGG, vai viesis, App vai pakalpojums tiek apkalpots tikai caur šo kāju.',
      unimportRefused: 'Imports joprojām tiek lietots — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Šis mezgls to tīklu jau saņem no cita fabric, kura dalībnieks tas ir: mezgls koplietotu tīklu ņem tikai caur VIENU savu kāju (divi tā paša L2 uplinki bridge bez STP ir cilpa). Atkartē to viena no diviem fabric portos vai LAGG.',
          otherFabricDerived: 'Dokuments nes tāda fabric bloku, uz kuru mezgls vairs nedeklarē kabeli: vispirms pielieto tā fabric plānu (tas piedāvā noņemt tā ierīces), vai pārņem tās ar take-ownership, ja fabric vairs nav.'
        },
        hint: 'O.3 derivācijas plāns: katram kabeļotam mezglam stāvoklis, diff atvasināts-vs-pašreizējais, DEKLARĒTĀ bond topoloģija, dual-stack flipi un strukturētie atteikumi/brīdinājumi. Tikai lasāms līdz EKSPLICĪTAM apply — nekas nekad nenolaižas uz mezgla pats.',
        refresh: 'Pārlādēt plānu',
        empty: 'Neviens mezgls nav kabeļots pie šīs fabric (un neviens vairs nenes tās bloku).',
        refusal: 'Atteikums',
        warning: 'Brīdinājums',
        generation: 'dokumenta paaudze {n}',
        state: {
          manual: 'Manuāls',
          derived: 'Atvasināts',
          diverged: 'Novirzījies'
        },
        topologyTitle: 'Deklarētā topoloģija',
        members: 'locekļi',
        primary: 'primārais',
        held: 'turēts uz VIENA locekļa',
        form: {
          perNetworkBond: 'Bond katram tīklam',
          singleBond: 'Viens rezerves bond',
          laggBond: 'LACP bond (LAGG)',
          singlePort: 'Viens ports'
        },
        colAction: 'Darbība',
        colKind: 'Veids',
        colDevice: 'Device',
        colDetail: 'Detaļa',
        action: {
          add: 'pievienot',
          remove: 'noņemt',
          replace: 'aizstāt'
        },
        diffEmpty: 'Nav gaidoša diff — piemērotais dokuments sakrīt ar renderu.',
        diffBlocked: 'Nav diff: augstāk esošie atteikumi bloķē šo mezglu.',
        phasePlanned: 'plānots (1. solis no 3)',
        phaseDraining: 'iztukšojas (2. solis no 3)',
        probeUnobserved: 'Iztukšošanas zonde: nekad nav ziņota — tukšums ir NEZINĀMS (retire tagad tiktu atteikts).',
        probeFailed: 'Iztukšošanas zonde: novērojums NEIZDEVĀS — zināmie laika zīmogi tiek pārnesti, nekad «tukšs», ko neviens nav mērījis.',
        probeActive: {
          zero: 'Zonde: {n} izveidotu savienojumu vēl uz vecās adreses',
          one: 'Zonde: {n} izveidots savienojums vēl uz vecās adreses',
          other: 'Zonde: {n} izveidoti savienojumi vēl uz vecās adreses'
        },
        probeLastActive: 'pēdējā aktivitāte {time}',
        probeEmpty: {
          zero: 'Zonde: tukšs {n} minūtes',
          one: 'Zonde: tukšs {n} minūti',
          other: 'Zonde: tukšs {n} minūtes'
        },
        probeEmptyUnknown: 'Zonde: tukšs (no kura brīža — nezināms).',
        impact: '{nics} vNIC un {apps} App uz šī mezgla izmanto šos tīklus: {list}',
        apply: 'Piemērot šim mezglam',
        applyTitle: 'Piemērot derivāciju — {node}',
        applyIntro: 'Atvasinātā konfigurācija pārraksta mezgla {node} tīkla dokumentu ({n} izmaiņas) pa tām pašām durvīm kā host-network redaktors — ieskaitot NetworkManager checkpoint un godīgu zondi. Plāna brīdinājumi zemāk ceļo kopā ar aktu: izlasiet tos pirms apstiprināšanas.',
        applyError: 'Apply neizdevās',
        applyRefused: 'Mezgls atteica:',
        planMoved: 'Fabric mainījās pēc šī priekšskatījuma — NEKAS netika piemērots. Plāns ir pārlādēts: paskatieties vēlreiz un mēģiniet no jauna.',
        retire: 'Izņemt',
        retireTitle: 'Neatgriešanās punkts — {address} izņemšana',
        restore: 'Atjaunot',
        restoreTip: 'Atpakaļ uz momentuzņēmumu pirms apply (paaudze {previous}) — viena soļa atsaukšana (H13)',
        restoreTitle: 'Atjaunot iepriekšējo dokumentu — {node}',
        restoreIntro: 'Mezgla {node} tīkla dokuments atgriežas momentuzņēmumā, kas uzņemts pirms pēdējā apply (paaudze {previous}), pārrakstīts kā paaudze {next} paaudzes {current} vietā. Worker to saskaņo kā jebkuru citu dokumentu.',
        restoreRedo: 'Aizstātais dokuments kļūst par jauno momentuzņēmumu: atkārtota atjaunošana ir redo.',
        restoreClosesChain: 'Momentuzņēmums ir manuālais dokuments pirms atvasināšanas: ķēde šeit noslēdzas — vairs nav atsaukšanas, mezgls ir manuāls līdz nākamajam apply.',
        restoreConfirm: 'Atjaunot',
        restoreError: 'Atjaunošana neizdevās',
        retireIntro: 'Tas galīgi noņem {address} ({network}) no {point}. Pēc šī akta ceļš atpakaļ ir APGRIEZTAIS flips — no jauna deklarēt veco adresi caur to pašu dzinēju — nekad akla atjaunošana.',
        retireOld: 'Vecā adrese (noņemta)',
        retireNew: 'Jaunā adrese (paliek)',
        retireEmptyFact: 'Iztukšošanas zonde ziņo adresi tukšu: šī noņemšana nepārtrauc nevienu novērotu savienojumu.',
        retireConfirm: 'Izņemt adresi',
        severActiveLoss: {
          zero: 'Pārtraukt {n} izveidotu savienojumu vēl uz vecās adreses — tie mirst ar šo aktu',
          one: 'Pārtraukt {n} izveidotu savienojumu vēl uz vecās adreses — tas mirst ar šo aktu',
          other: 'Pārtraukt {n} izveidotus savienojumus vēl uz vecās adreses — tie mirst ar šo aktu'
        },
        severUnknownLoss: 'Pieņemt NEZINĀMO: zonde nekad nav novērojusi šo adresi (vai novērojums neizdodas) — dzīvi savienojumi var tikt pārtraukti.'
      },
      title: 'Fabric',
      createTitle: 'Izveidot fabric',
      networks: 'Tīkli',
      switches: 'Switch',
      ports: 'Porti',
      laggs: 'LAGG',
      subnets: 'Apakštīkli',
      tabOverview: 'Pārskats',
      tabNetworks: 'Loģiskie tīkli',
      tabSwitches: 'Switch',
      overviewHint: 'Fabric vienā acu uzmetienā: katrs loģiskais tīkls ar MTU un apakštīklu (VLAN dzīvo tikai kartējumos pa portiem un LAGG — viens un tas pats tīkls dažādos portos var ceļot ar dažādiem tagiem). Fabric ir ĀRĒJAS infrastruktūras reģistrs — TVirt novēro un deklarē, nekad neveic provizionēšanu un pieskaras tikai tām NIC, kas reģistrētas tā pārziņā.',
      absorptionHint: 'Katrs šeit deklarētais apakštīkls tajā pašā rakstīšanas reizē ATVASINA savu ierakstu IPAM reģistrā — tas dzīvo un mirst kopā ar tīklu.',
      scopeFixedHint: 'Scope ir fiksēts klastera saknē: fiziskā infrastruktūra pēc definīcijas attiecas uz visu klasteri.',
      networksHint: 'Katram tīklam ir obligāta MTU (noklusējums 1500) un obligāts apakštīkls; šeit deklarētā vārteja, DNS serveri un statiskie maršruti ir VIENĪGAIS AVOTS serveru NIC, lietotnēm un tīkla pakalpojumiem.',
      switchesHint: 'Manuālais reģistrs: ports ir neizmantots, kartēts (untagged datplūsma un pa VLAN tagiem uz loģiskajiem tīkliem) vai LAGG dalībnieks — dalībniekam nav savu kartējumu.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Obligāts — IPAM no tā automātiski atvasina reģistra ierakstu',
      nodeAddressing: 'Mezglu adresācija',
      nodeAddressingNone: 'Nav — mezglam adrese netiek piešķirta',
      nodeAddressingPool: 'Pool — viena pastāvīga adrese katram apkalpotajam mezglam',
      nodeAddressingHint: 'Ar Pool fabric atvasināšana katram apkalpotajam mezglam piešķir adresi no TVirt rezervētajiem diapazoniem (pēc piešķiršanas pastāvīga).',
      backing: 'Backing',
      gateway: 'Vārteja',
      ranges: 'Rezervētie diapazoni',
      dns: 'DNS serveri (atdalīti ar komatu)',
      dnsShort: 'DNS',
      singleSourceHint: 'Šeit deklarētā vārteja, DNS un maršruti ir vienīgais avots — serveru NIC, lietotnes un tīkla pakalpojumi smeļas no šejienes',
      routesTitle: 'Statiskie maršruti',
      routeDestination: 'Galamērķis (CIDR)',
      routeVia: 'Caur (next hop)',
      portUsed: 'Izmantots',
      vlanMappings: 'VLAN kartējumi',
      vlanTag: 'VLAN tags',
      vlanNetwork: 'Loģiskais tīkls',
      nameTaken: 'Nosaukums šajā fabric jau ir aizņemts',
      addNetwork: 'Pievienot tīklu',
      editNetwork: 'Rediģēt tīklu',
      deleteNetwork: 'Noņemt tīklu',
      deleteNetworkConfirm: 'Vai noņemt loģisko tīklu {name} no fabric? Tā atvasinātais apakštīkls IPAM mirst kopā ar to (atteikts, kamēr to izmanto kāds pakalpojums vai lietotne). Portu un LAGG kartējumi, kas uz to norāda, tiek notīrīti.',
      switchName: 'Switch',
      portName: 'Ports',
      positionHint: 'Fiziskais novietojums (neobligāts) — tāds pats vārdu krājums kā serveru novietojumam; tikai deklaratīvs',
      addSwitch: 'Pievienot switch',
      editSwitch: 'Rediģēt switch',
      deleteSwitch: 'Noņemt switch',
      deleteSwitchConfirm: 'Vai noņemt switch {name} ar visiem tā portiem? LAGG attiecīgi sarūk (un mirst, ja paliek mazāk par diviem portiem).',
      addPort: 'Pievienot portu',
      editPort: 'Rediģēt portu',
      deletePort: 'Noņemt portu',
      deletePortConfirm: 'Vai noņemt portu {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tags:tīkls)',
      taggedShort: 'Tagged',
      portCabling: 'Kabelējums',
      portState: 'Stāvoklis',
      stateUnused: 'neizmantots',
      stateMapped: 'kartēts',
      laggPortGuard: 'Portu, kas ir LAGG dalībnieks, rediģē no LAGG puses',
      laggsTitle: 'LAGG',
      laggsHint: 'LAGG ir 2+ porti LACP režīmā, un tas var šķērsot switch (MLAG, caurspīdīgi); tajā iekļaujas tikai neizmantoti porti, LAGG ir kartēšanas virsma, izņemts ports atgriežas neizmantoto vidū.',
      addLagg: 'Pievienot LAGG',
      editLagg: 'Rediģēt LAGG',
      deleteLagg: 'Noņemt LAGG',
      deleteLaggConfirm: 'Vai noņemt LAGG {name}? Tā dalībnieku porti atgriežas neizmantoto vidū.',
      lacpRate: 'LACP rate',
      laggPorts: 'Dalībnieku porti (2+)',
      laggPortsHint: 'Iekļaujas tikai neizmantoti porti — vispirms atbrīvojiet kartēto portu',
      noNetworks: 'Nav deklarēts neviens loģiskais tīkls.',
      noSwitches: 'Nav deklarēts neviens switch.',
      noLaggs: 'Nav deklarēts neviens LAGG.',
      staleConflict: 'Cits operators mainīja šo fabric, kamēr tu to rediģēji: saglabāšana tika noraidīta, lai neizdzēstu viņa darbu. Tavas izmaiņas joprojām ir šeit, neskartas. Atjauninātais fabric jau ir pārlādēts: apstiprini vēlreiz, lai tās uzliktu virsū, vai atcel un paskaties, kas ir mainījies.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Tikai atvasināts: katrs apakštīkls rodas no fabric loģiskā tīkla vai no overlay — to maina avotā. Piešķirtās adreses rāda, KAS tās tur; TVirt rezervētie diapazoni ir automātiskās piešķiršanas pūli.',
      search: 'Meklēt pēc nosaukuma, CIDR vai adreses',
      empty: 'Nav neviena tīkla — deklarējiet fabric loģisko tīklu vai overlay apakštīklu: IPAM atvasinās no tiem automātiski.',
      reserved: 'TVirt rezervētie diapazoni',
      address: 'Adrese',
      origin: 'Izcelsme',
      origin_declared: 'deklarēts',
      origin_observed: 'novērots',
      holder: 'Turētājs',
      noAddresses: 'Šajā apakštīklā nav zināma neviena adrese.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Rediģēt avotā'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Ugunsmūra grupas',
      createTitle: 'Jauna ugunsmūra grupa',
      editTitle: 'Rediģēt ugunsmūra grupu',
      empty: 'Vēl nav nevienas ugunsmūra grupas — izveidojiet vienu: atkalizmantojama noteikumu vārdnīca, uz kuru viesu NIC atsaucas pēc nosaukuma.',
      nameHint: 'Burti, cipari un . - _ vidū; unikāls sava scope ietvaros (vienādus nosaukumus citur atšķir /scope/nosaukums)',
      description: 'Apraksts',
      descriptionHint: 'Viena nodoma rinda, redzama visur, kur grupu izvēlas',
      enforced: 'Uzspiesta scope līmenī',
      enforcedHint: 'Izslēgts: tīra vārdnīca — noteikumi saista tikai tās NIC, kas atsaucas uz grupu. Ieslēgts: noteikumi saista ikvienu viesa NIC ar ieslēgtu ugunsmūri zem grupas scope, ar atsauci vai bez.',
      enforcedChip: 'Uzspiesta',
      enforcedChipHint: 'Noteikumi saista ikvienu viesa NIC ar ieslēgtu ugunsmūri zem grupas scope, ar atsauci vai bez',
      enforceWarning: 'Ieslēdzot uzspiešanu, noteikumi nākamajā saskaņošanā saistīs IKVIENU viesa NIC ar ieslēgtu ugunsmūri zem {scope}, arī bez tiešas atsauces — un aktīvas chain iekšienē senča drop ir galīgs: apakšējie līmeņi to vairs neatver.',
      unenforceInfo: 'Noņemot uzspiešanu, noteikumi paliek tikai uz tām NIC, kas tieši atsaucas uz grupu.',
      rules: 'Noteikumi',
      tabOverview: 'Pārskats',
      tabRules: 'Noteikumi',
      orderHint: 'Rindu secība IR izvērtēšanas secība grupas ietvaros: uzvar pirmais noteikums, kas sakrīt.',
      statefulHint: 'Stateful ir iebūvēts: atbildes uz ielaisto datplūsmu iziet pašas no sevis (established/related tiek pieņemtas, invalid atmests — to iešļircina dzinējs, ar roku to neraksta).',
      noRules: 'Nav noteikumu — vārdnīca vēl top: atsaukties uz to ir likumīgi un tas nerada neko.',
      addRule: 'Pievienot noteikumu',
      direction: 'Virziens',
      directionIn: 'Ienākošais',
      directionOut: 'Izejošais',
      action: 'Darbība',
      action_accept: 'Pieņemt',
      action_drop: 'Atmest',
      action_reject: 'Noraidīt',
      protocol: 'Protokols',
      protocolAny: 'Jebkurš',
      ports: 'Porti',
      source: 'Avots',
      dest: 'Galamērķis',
      comment: 'Komentārs',
      addressHint: 'IPv4 CIDR vai <fabric>/<loģiskais tīkls>; tukšs = jebkurš',
      moveUp: 'Pārvietot uz augšu',
      moveDown: 'Pārvietot uz leju',
      nicFirewall: 'Ugunsmūris',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Ugunsmūra grupas',
      nicGroupsPlaceholder: 'Izvēlieties grupu…',
      nicGroupsHint: 'Redzamās grupas, ieskaitot augstāko scope grupas (izmantojamas lejup, tāpat kā tagi)',
      nicGroupCount: { zero: '{n} ugunsmūra grupu', one: '{n} ugunsmūra grupa', other: '{n} ugunsmūra grupas' },
      nicOff: 'Ugunsmūris izslēgts',
      pendingRestartHint: 'Ugunsmūra izmaiņas seko modelim saglabāts/piemērots: tās gaida nākamo barošanas ciklu (PendingRestart). Augstāko scope uzspiestās grupas piemērojas, kad NIC ugunsmūris ir ieslēgts.',
      appConvergeHint: 'Ugunsmūra izmaiņas piemērojas konteinera nākamajā saskaņošanā. Augstāko scope uzspiestās grupas piemērojas, kad ugunsmūris ir ieslēgts.',
      enforcedAncestors: 'Uzspiestas no augstākiem scope',
      enforcedAncestorsHint: 'Šī grupa piemērojas ikvienai NIC zem sava scope ar IESLĒGTU ugunsmūri — slēdzis ir NIC galvenais slēdzis (izslēgts = nekādas chain vispār, senčus ieskaitot); aktīvas chain iekšienē senča autoritāte ir galīga: tā drop zemāk vairs neatveras.'
    }
  }
}
